import gql from 'graphql-tag'

/**
 * Query
 */
const GET_BY_ID = gql`
    query otherConfigById ($id: ID!) {
        otherConfigById (id: $id) {
            id
            name
            value
            is_active
            status_text
        }
    }
`
/**
 * Mutations
 */

const UPDATE = gql`
    mutation updateOtherConfig ($id: ID!, $input: UpdtaeOtherConfigInput!) {
        updateOtherConfig (id: $id, input: $input) {
            id
            name
            value
            is_active
            status_text
        }
    }
`

export {
    GET_BY_ID,
    UPDATE
}
